<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  mounted() {
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: !!this.title,
        text: this.title,
      },
      legend: {
        position: "top",
      },
      scales: {
        xAxes: [
          {
            stacked: true,
          },
        ],
        yAxes: [
          {
            stacked: true,
          },
        ],
      },
      onClick: this.handleClick,
    };
    this.renderChart(this.chartData, options);
  },
  methods: {
    handleClick(event, items) {
      if (items.length > 0) {
        const clickedData = this.chartData.labels[items[0]._index];
        this.$emit("chartClicked", clickedData);
        // Navigate to another page with the clicked data
        // this.$router.push({ name: 'details', params: { data: clickedData }});
      }
    },
  },
};
</script>
